import Fab from '@material-ui/core/Fab/Fab';
import StarsIcon from '@material-ui/icons/Stars';
import AddIcon from '@material-ui/icons/Add';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import _ from 'lodash';
import IconButton from '@material-ui/core/IconButton';
import LocationOn from '@material-ui/icons/LocationOn';
import Tooltip from '@material-ui/core/Tooltip';
import StarIcon from '@material-ui/icons/Star';
import { ADDRESS_DIALOG, CONFIRM_DIALOG } from '../../../redux/constants/dialogs';
import { findCountry } from '../../../utils/countries';

import { formatAddress, replaceOrAdd } from '../../../utils/helper';

import Grid from '../../Common/Grid';
import getNoDataCellComponent from '../../Common/NoDataCellComponent';

import styles from './styles';

const COLUMNS = [
  { name: 'primaryAddress', title: ' ' },
  { name: 'name', title: 'Name' },
  { name: 'address', title: 'Address' },
  { name: 'action', title: ' ' },
];

const COLUMN_EXTENSIONS = [
  { columnName: 'primaryAddress', width: 80 },
  { columnName: 'name', width: 150 },
  { columnName: 'action', width: 100 },
];

const getCellComponent = (onSetPrimary) => ({ column, value, row }) => {
  switch (column.name) {
    case 'primaryAddress':
      return row && row.primary ?
        <Tooltip title="Primary Address"><StarIcon color="secondary" style={styles.primaryIcon}/></Tooltip> : null;
    case 'address':
      return formatAddress(row);
    case 'action':
      return !row || !row.primary ? (
        <Tooltip title="Set as primary address"><IconButton onClick={() => onSetPrimary(row)}>
          <StarsIcon/>
        </IconButton></Tooltip>) : null;
    default:
      return value;
  }
};

class AddressesGrid extends Component {

  handleSetPrimary = (address) => {
    console.log('handleSetPrimary', this.props.addresses, address);
    this.props.onChange(this.props.addresses.map((a) => {
      a.primary = a.id === address.id;
      return a;
    }));
  }

  handleConfirmDelete = (address) => {
    return new Promise((resolve, reject) => {
      this.props.showDialog(CONFIRM_DIALOG, {
        title: 'Are you sure you wish to remove this address?',
        onConfirm: () => this.props.onChange(this.props.addresses.filter((a) => a.id !== address.id)),
        onReject: reject,
      });
    });
  }

  handleSuccess = (address) => {
    this.props.onChange(replaceOrAdd(this.props.addresses, address));
  }

  render() {
    const { addresses, showDialog } = this.props;
    const data = {
      data: addresses,
      pagination: {
        totalCount: addresses.length,
      }
    };

    // TODO get account default
    const buttons = [<Tooltip key="create" title="Add Address">
      <Fab
        color="secondary"
        aria-label="add"
        style={styles.add}
        onClick={() => showDialog(ADDRESS_DIALOG, {
          address: { country: findCountry('US') },
          onSuccess: this.handleSuccess
        })}
        size="small"
        id="addAddress"
      >
        <AddIcon/>
      </Fab>
    </Tooltip>];

    return (<Grid
      buttons={buttons}
      columns={COLUMNS}
      columnExtensions={COLUMN_EXTENSIONS}
      cellComponent={getCellComponent(this.handleSetPrimary)}
      data={data}
      fetch={_.noop}
      noDataCellComponent={getNoDataCellComponent(<LocationOn style={styles.noData}/>, 'addresses')}
      onEdit={(address) => this.props.showDialog(ADDRESS_DIALOG, { address, onSuccess: this.handleSuccess })}
      onRemove={this.handleConfirmDelete}
    />);
  }
}

AddressesGrid.propTypes = {
  addresses: PropTypes.array,
  onChange: PropTypes.func,
  showDialog: PropTypes.func,
};

export default AddressesGrid;



// WEBPACK FOOTER //
// ./src/components/Addresses/AddressesGrid/index.js